export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voltar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por favor, forneça um novo nome para o ativo"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Este nome ajudará você a identificar a carteira mais facilmente em sua lista de ativos."])}
}